import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SessionContextService } from '../../../../core/services/session-context.service';

interface SheetTile {
  label: string;
  route: string;
  module: string;
}

/** The four broker rate sheets, in display order. */
const SHEET_TILES: SheetTile[] = [
  { label: 'MYGA',   route: '/rate-sheet',              module: 'fa_broker_rate_sheet' },
  { label: 'Fixed',  route: '/standard-fixed-rate-sheet', module: 'fa_std_broker_rate_sheet' },
  { label: 'Index',  route: '/ia-rate-sheet',            module: 'index_broker_rate_sheet' },
  { label: 'Struct', route: '/rila-rate-sheet',          module: 'index_var_broker_rate_sheet' },
];

/**
 * Four sheet-selector tiles at the top of every broker rate-sheet rail —
 * the rate-sheet analogue of the /rates product-type pill tabs. Clicking a
 * tile routes to that sheet (rail persists via the route's preserveRail flag).
 * Tiles without module permission are filtered out.
 */
@Component({
  selector: 'app-rate-sheet-tiles',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  template: `
    <div class="rs-tiles">
      @for (t of visibleTiles(); track t.route) {
        <a class="rs-tile"
           [routerLink]="t.route"
           routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: true }">{{ t.label }}</a>
      }
    </div>
  `,
  styles: [`
    .rs-tiles { display: grid; grid-template-columns: repeat(4, 1fr); gap: 4px; padding: 10px 14px; border-bottom: 1px solid var(--border-light); }
    .rs-tile { height: 30px; display: flex; align-items: center; justify-content: center; font-size: 11.5px; font-weight: 700; letter-spacing: .02em; color: var(--muted); background: var(--panel, #f4f6f9); border: 1px solid var(--border); border-radius: 5px; text-decoration: none; cursor: pointer; }
    .rs-tile:hover { color: var(--text); border-color: var(--border2, var(--border)); }
    .rs-tile.active { background: var(--navy); color: #fff; border-color: var(--navy); }
  `],
})
export class RateSheetTilesComponent {
  private session = inject(SessionContextService);
  protected readonly visibleTiles = computed(() =>
    SHEET_TILES.filter(t => this.session.hasModule(t.module)),
  );
}
